import {DeviceType} from '$lib/classes/_enum/device-type';

export class Device {

    private _current = $state(DeviceType.Desktop)

    get current() { return this._current }

    setDevice(matches: boolean) {
        if (matches) {
            this._current = DeviceType.Mobile
        } else {
            this._current = DeviceType.Desktop
        }
    }

    constructor(matchMedia: Window['matchMedia'] | null) {
        if (matchMedia) {

            const mediaQueryList = matchMedia('(max-width: 1000px)')
            this.setDevice(mediaQueryList.matches)

            mediaQueryList.addEventListener('change', (mediaQueryList) => {
                this.setDevice(mediaQueryList.matches)
            })
        }
    }
}